<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper/modules";

// CSS ضروري
import "swiper/css";
import "swiper/css/pagination";
</script>

<template>
  <div class="col-xl-4">
    <div class="card card-xl-stretch mb-5 mb-xl-8">
      <!-- Header -->
      <div class="card-header align-items-center border-0 mt-3">
        <h3 class="card-title align-items-start flex-column">
          <span class="fw-bold text-dark fs-3">
            <i
              class="fa-solid fa-calendar-check"
              style="
                border-radius: 10px;
                padding: 8px 10px;
                background: #93f7ff63;
                color: #00ceba;
              "
            ></i>
            أقرب جلسة لديك</span
          >
          <small class="text-gray-400 mt-2 fw-semibold fs-6">
            تصفح هنا أقرب جلسة لديك
          </small>
        </h3>
      </div>

      <!-- Body -->
      <div class="card-body pt-5">
        <Swiper
          :modules="[Pagination, Autoplay]"
          :slides-per-view="1"
          :space-between="10"
          :pagination="{ clickable: true }"
          :autoplay="{ delay: 3000, disableOnInteraction: false }"
          loop
          class="mySwiper"
        >
          <!-- Slide 1 -->
          <SwiperSlide>
            <div class="d-flex mb-7">
              <div class="symbol flex-shrink-0 me-4">
                <img
                  src="https://cdn.academia.org.ly/user_images/1675043372DF05D00C-14D1-4496-A597-7C51296D838B.jpeg"
                  class="mw-100"
                  style="height: 80px; width: 85px"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1">
                <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                  <a
                    href="#"
                    class="fs-5 text-gray-800 text-hover-primary fw-bold"
                    style="font-weight: 700 !important"
                  >
                    د. محمد شلوف
                  </a>
                  <span class="text-gray-400 fw-semibold fs-7 my-1"
                    >محاضر في منصة أكاديميا</span
                  >
                  <small class="text-gray-400 fw-semibold fs-8">
                    عنوان الجلسة
                    <a href="#" class="text-success fw-bold">جلسة إستشارة</a>
                  </small>
                  <small class="text-gray-400 fw-semibold fs-8">
                    تاريخ الجلسة
                    <a href="#" class="text-success fw-bold">20-08-2025 12:00</a>
                  </small>
                </div>
                <div class="text-end py-lg-0 py-2">
                  <span class="text-gray-800 fw-bolder fs-3">
                    <b class="badge badge-light mb-1" style="padding: 12px 10px"
                      >تبدأ الجلسة <br />
                      بعد 3 دقائق</b
                    >
                  </span>
                  <span class="text-gray-400 fs-7 fw-semibold d-block">
                    <button class="btn btn-success btn-sm">إنضم الآن</button>
                  </span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <!-- Slide 2 -->
          <SwiperSlide>
            <div class="d-flex mb-7">
              <div class="symbol flex-shrink-0 me-4">
                <img
                  src="https://cdn.academia.org.ly/user_images/1675043372DF05D00C-14D1-4496-A597-7C51296D838B.jpeg"
                  class="mw-100"
                  style="height: 80px; width: 85px"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1">
                <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                  <a
                    href="#"
                    class="fs-5 text-gray-800 text-hover-primary fw-bold"
                    style="font-weight: 700 !important"
                  >
                    أ. أحمد الفيتوري
                  </a>
                  <span class="text-gray-400 fw-semibold fs-7 my-1"
                    >محاضر في منصة أكاديميا</span
                  >
                  <small class="text-gray-400 fw-semibold fs-8">
                    عنوان الجلسة
                    <a href="#" class="text-success fw-bold">مراجعة نهائية</a>
                  </small>
                  <small class="text-gray-400 fw-semibold fs-8">
                    تاريخ الجلسة
                    <a href="#" class="text-success fw-bold">21-08-2025 18:00</a>
                  </small>
                </div>
                <div class="text-end py-lg-0 py-2">
                  <span class="text-gray-800 fw-bolder fs-3">
                    <b class="badge badge-light mb-1" style="padding: 12px 10px"
                      >تبدأ الجلسة <br />
                      بعد 6 ساعات</b
                    >
                  </span>
                  <span class="text-gray-400 fs-7 fw-semibold d-block">
                    <button class="btn btn-success btn-sm">إنضم الآن</button>
                  </span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "DashboardView",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      streams: [],
      isLoadingStreams: false,
    };
  },
  mounted() {
    this.getNearLive();
  },
  methods: {
    async getNearLive() {
      this.isLoadingStreams = true; // ✅ إظهار اللودر عند بدء الجلب
      try {
        const response = await fetch(`${apiUrl}/livestream/get-near-live-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          this.streams = await response.json();
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },
    async joinLiveStream(event, id) {
      let button = event.target;

      let originalContent = button.innerHTML;

      button.innerHTML = `<span class="spinner-border spinner-border-sm"></span> جاري الانضمام...`;
      button.classList.add("disabled");

      try {
        const response = await fetch(`${apiUrl}/livestream/token/` + id, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        });

        let data = await response.json();

        if (data.token) {
          window.open(`https://live.academia.ly/?token=${data.token}`, "_blank");
        } else {
          alert("فشل في جلب التوكن، حاول مرة أخرى!");
        }
      } catch (error) {
        console.error("Error fetching token:", error);
        alert("حدث خطأ أثناء الاتصال بالخادم!");
      } finally {
        button.innerHTML = originalContent;
        button.classList.remove("disabled");
      }
    },

    isLive(stream) {
      const now = new Date();
      return (
        new Date(stream.live_starts_at) <= now && new Date(stream.live_ends_at) >= now
      );
    },
    isEnded(stream) {
      return new Date(stream.live_ends_at) < new Date();
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString("ar-EG", { dateStyle: "full", timeStyle: "short" });
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.card-body {
  text-align: right;
}
</style>
